<template>
	<div class="recharge" v-title="title">
		<navtop v-bind:index="''"></navtop>
		<!--<div class="account">
			<img v-bind:src="userImg||'../../../static/zhubo.jpg'" />
			<div>
				<p>ID:{{baseInfo.uid}}</p>
				<p>昵称：{{baseInfo.nick!=="undefined"?baseInfo.nick:'齐齐牛人'}}</p>
			</div>
			<a v-on:click="switchCoun" v-if="isHideLogout">切换账号</a>
		</div>-->
		<div class="charge-con">
			<div class="ye">
				<p>剩余齐齐豆</p>
				<span>{{hasQiqiDou}}</span>
			</div>
			<div class="chargeWrap">
				<ul class="chargeList">
					<li v-on:click="selectedAmount(1,0)" v-bind:class="index==0&&'cur'">
						<input type="tel" v-model="qiqidou" v-toNumber placeholder="齐齐豆"/><span>万</span><br />
						<a>{{qiqidou*10|limitBy}}元</a>
					</li>
					<li v-on:click="selectedAmount(1,1)" v-bind:class="index==1&&'cur'">
						<p>1万齐齐豆</p>
						<a>10元</a>
					</li>
					<li v-on:click="selectedAmount(20,2)" v-bind:class="index==2&&'cur'">
						<p>20万齐齐豆</p>
						<a>200元</a>
					</li>
					<li v-on:click="selectedAmount(50,3)" v-bind:class="index==3&&'cur'">
						<p>50万齐齐豆</p>
						<a>500元</a>
					</li>
					<li v-on:click="selectedAmount(300,4)" v-bind:class="index==4&&'cur'">
						<p>300万齐齐豆</p>
						<a>3000元</a>
					</li>
					<li v-on:click="selectedAmount(500,5)" v-bind:class="index==5&&'cur'">
						<p>500万齐齐豆</p>
						<a>5000元</a>
					</li>
				</ul>
				<div class="charge-btn" v-on:click="pay">立即充值</div>
				<div class="tips">
					<p>充值提示:</p>
					<p>1:请确认您的账号确认无误。</p>
					<p>2:充值比例为1:1000即1元人民币=1000齐齐豆</p>
					<p>3:如果有任何问题请联系客服QQ:8007777777</p>
				</div>
			</div>
		</div>
		<!--<navbottom></navbottom>-->
		<div class="pop" v-if="showTips">
			<p>请输入1-9999之间的数字</p>
			<button v-on:click="showTips=false">确定</button>
			<i v-on:click="showTips=false">x</i>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import navtop from '../dating/navTop'
	import navbottom from '../dating/navBottom'
	import cookie from '../../libs/cookie'

	export default {
		name: 'index',
		data() {
			return {
				title: '充值齐齐豆',
				baseInfo: {
					nick: cookie.get('nick'),
					uid: cookie.get('uid'),
				},
				qiqidou: '',
				showTips:false,
				userImg:cookie.get('photo'),
				index:0,
				hasQiqiDou:0
			}
		},
		computed:{
			isHideLogout(){
				var channel=cookie.get('channelid');
				return (( channel != 54)&&(channel != 55)&&(channel != 10102))
			},
		},
		components: {
			navtop,
			navbottom
		},
		mounted(){
			var _this=this;
			if(!cookie.get('wxopenid') && this.isWeixin()){
				if(this.querystr("openid")){
					cookie.set('wxopenid',this.querystr("openid"),{domain:"qxiu.com"})
				}else{
//					location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3d"+ location.protocol.slice(0,-1) +"%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"; 
					location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbdf212b5475d03c2&redirect_uri=http%3a%2f%2flogin.m.qxiu.com%2fcgi%2flogin%2fcallback%3floginType%3dwechatGZH%26target%3dweblive%26loginDataTransfer%3dparam%26toUrl%3dhttps%3a%2f%2fh5.qxiu.com%2F%23%2Frecharge&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"; 
				}
			}
			$.ajax({
				type: "get",
				url: "https://api-live.qxiu.com/webProxy/cgi/webQiQiDouQuery?userId="+cookie.get('uid')+'&meck='+cookie.get('mcheck'),
				async: true,
				dataType: "jsonp",
				success: function(res) {
					if(res.retcode == 0){
						_this.hasQiqiDou = res.result.qiqidou
					}else{
						alert(res.result.msg)
					}
				}
			});
			
			if(_this.querystr("roomid")){
				cookie.set('roomid',_this.querystr("roomid"), {domain: 'qxiu.com',encode: true})
			}else{
				cookie.remove('roomid',{domain:'qxiu.com'})
			}
		},
		methods: {
			switchCoun() {
				cookie.remove('uid',{domain:'qxiu.com'})
				cookie.remove('accessToken',{domain:'qxiu.com'})
				cookie.remove('openid',{domain:'qxiu.com'})
				cookie.remove('webToken',{domain:'qxiu.com'})
				cookie.remove('refreshToken',{domain:'qxiu.com'})
				cookie.remove('mcheck',{domain:'qxiu.com'})
				cookie.remove('pgv_pvi',{domain:'qxiu.com'})
				cookie.remove('closedownLoad',{domain:'qxiu.com'})
				cookie.remove('tempid',{domain:'qxiu.com'})
				cookie.remove('tempmcheck',{domain:'qxiu.com'})
				cookie.remove('wxopenid',{domain:'qxiu.com'})
				cookie.remove('bindPhone',{domain:'qxiu.com'})
				this.$store.commit('getCurview', 'loginmode')
				location.hash = '/'
			},
			selectedAmount(amount,index){
				this.qiqidou=amount;
				this.index=index;
			},
			pay() {
				var rmb=this.qiqidou*10;
				if(!rmb){
					alert("金额不能为空")
				}else if(rmb&&!this.showTips){
					var u = navigator.userAgent,
					isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
					channel=cookie.get('channelid');
					if(channel==55 && isiOS){
						location.href = "https://itunes.apple.com/us/app/id1369635949?l=zh&ls=1&mt=8";
						return;
					}
//					if((channel==54)||(channel==55)||(channel==10102)){
//						this.qqPay(rmb)
//					}else{
						this.$store.commit('getOrderRmb', rmb)
						location.hash = '/pay'+(this.querystr('roomid')?('?roomid='+this.querystr('roomid')):'')
//					}
				}
			},
			querystr(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.href.slice(window.location.href.indexOf('?')).substr(1).match(reg);
				if(r != null) return unescape(r[2]);
				return null;
			},
			qqPay(rmb){
				var buyerId = cookie.get('uid');
				var openid = cookie.get('openid');
				var openkey = cookie.get('accessToken');
				var payToken = cookie.get('accessToken');
				var goodsQty = rmb;
				var oemId =	cookie.get('oemid')||201;
				var channelId =	cookie.get('channelid');
				$.ajax({
					  url: 'https://order.qxiu.com/v2/midasPay/createOrder',
					  data:{buyerId:buyerId,userId:buyerId,goodsQty:goodsQty,openid:openid,openkey:openkey,payToken:payToken,roomId:0,agentId:0,oemId:oemId,channelId:channelId,urlencode:true},
				      type: 'get',
				      dataType:"jsonp", 
					  jsonp: 'callbackname',
				      async:true,
				      success: function(data){
				      		if(data.state==0){
					      		//params.params=data.rs.sandbox; 
					      		//location.href="https://pay.qq.com/h5/index.shtml?pf=qq_m_qq-10000144-android-10000144-1234&m=buy&c=goods&_version=v3&params=pf&dc=qqcard,mcard,hfpay,yb&sandbox="+data.content.sandbox+"&params="+data.content.params;
				      			var url ="https://pay.qq.com/h5/index.shtml?openid="+openid+"&openkey="+openkey+"&sessionid=openid&sessiontype=kp_actoken&pf=qq_m_qq-10000144-android-10000144-1234&m=buy&c=goods&_version=v3&params=pf&dc=qqcard,mcard,hfpay,yb&params="+data.content.params;
					      		if(data.content.sandbox == 1){//沙箱环境
					      			url = url+"&sandbox="+data.content.sandbox
					      		}
				      			location.href=url;
				      		}else{
				      			alert(data.msg);
				      		}
				      }
				});
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			}
		},
		watch: {
			qiqidou() {
				let reg = /\D/g
				if(reg.test(this.qiqidou)) {
					this.qiqidou=0
				}
			}
		},
		directives:{
			toNumber:{
				bind: function(el) {
					let reg = /^[1-9]([0-9]{0,3})$/g
					el.addEventListener('keyup',function(){
						var toggle = reg.test(el.value);
						reg.test(el.value)
						if(!toggle&&el.value){
							el.value=el.value.slice(0,4)
							alert("请输入1-9999之间的数字")
						}
					},false);
				}
			}
		},
		filters:{
			limitBy(value){
				if(value>99990){
					return Math.floor(value/100)*10
				}else{
					return value
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.recharge{
		background: url(../../img/dating/recharge.jpg) no-repeat;
		padding-bottom: 3.5rem;
	}
	.charge-con{
		margin-top: 2.2rem;
	}
	.account {
		padding: 0.4rem;
		background: #fff;
		overflow: hidden;
	}
	
	.account img {
		float: left;
		width: 1.08rem;
		height: 1.08rem;
		border-radius: 50%;
	}
	
	.account>div {
		float: left;
		margin-left: 0.2rem;
	}
	
	.account>div p {
		font-size: 0.48rem;
		color: #666;
		line-height: 0.56rem;
	}
	
	.account>a {
		float: right;
		width: 2.52rem;
		height: ;
		line-height: 1.08rem;
		color: #00A0E9;
		border: 0.04rem solid #00A0E9;
		border-radius: 0.12rem;
		text-align: center;
		font-size: 0.52rem;
	}
	.ye{
		padding: 1.8rem 0 1.6rem;
		text-align: center;
		color: #fff;
	}
	.ye p{
		font-size: 0.56rem;
		font-weight: 600;
		margin-bottom: 0.5rem;
	}
	.ye span{
		font-size: 1.44rem;
		font-weight: 600;
	}
	.chargeWrap{
		width: 14rem;
		margin: 0 auto;
		padding: 2rem 0 1.2rem;
		background: #fff;
		border-radius: 0.9rem;
	}
	.chargeList {
		text-align: center;
	}
	
	.chargeList>li {
		display: inline-block;
		width: 4rem;
		height: 2.6rem;
		margin-bottom: 0.8rem;
		border: 0.04rem solid #ccc;
		border-radius: 0.4rem;
		font-size: 0.56rem;
		font-weight: 600;
		line-height: 0.8rem;
		background-size: 0.6rem;
		vertical-align: middle;
	}
	
	.chargeList>li.cur {
		color: #B3B3B3;
		border-color: #FF5082;
		background: url(../../img/dating/cur.png) no-repeat bottom right;
		background-size: 0.86rem;
	}
	
	.chargeList>li.cur p{
		color: #FF5082;	
	}
	
	.chargeList>li.cur a{
		color: #FF5082;	
	}
	
	.chargeList>li>p{
		margin-top: 0.6rem;
		color: #2a2a2a;
		font-weight: bold;
		font-size: 0.56rem;
	}
	.chargeList>li>a {
		text-align: center;
		margin-top: 0.44rem;
		line-height: 1rem;
		color: #C4C4C4;
	}
	
	.chargeList>li input {
		width: 2.4rem;
		height: 0.92rem;
		margin-top: 0.5rem;
		background: transparent;
		border: none;
		text-align: center;
		outline: none;
		-webkit-appearance: none;
	}
	.chargeList>li:first-child a{
		display: inline-block;
		margin: 0;
		width: 3rem;
		border-top: 1px solid #ccc;
	}
	.chargeList>li:first-child span{
		color: #666;
		vertical-align: bottom;
	}
	.charge-btn{
		width: 12rem;
		height: 1.8rem;
		margin: 3.4rem auto 0;
		text-align: center;
		line-height: 1.8rem;
		color: #fff;
		font-size: 0.6rem;
		background: linear-gradient(to right,#FF7E6E,#FD2092);
		border-radius: 1rem;
	}
	.tips {
		padding: 0.8rem 1rem 0;
		text-align: left;
		margin-top: 1rem;
		font-size: 0.48rem;
	}
	
	.tips p {
		font-size: 0.48rem;
		line-height: 0.9rem;
		color: #acacac;
	}
	.pop{
		width:11.12rem;
		height: 4.8rem;
		position: absolute;
		top: 50%;
		left: 50%;
		border: 1px solid #D5D5D3;
		margin: -2.9rem 0 0 -5.5rem;
		padding-top: 1.5rem;
		background: #FFF;
		border-radius: 0.4rem;
		text-align: center;
		z-index: 10;
	}
	.pop p{
		font-size: 0.56rem;
		color: #666;
	}
	.pop button{
		width: 6rem;
		height: 1.2rem;
		background: #EE3F81;
		border-radius: 0.24rem;
		border: none;
		margin-top: 1.5rem;
		color: #fff;
	}
	.pop i{
		position: absolute;
		top: 0;
		right: 0.4rem;
		font-size: 1rem;
	}
</style>


// WEBPACK FOOTER //
// recharge.vue?683988d6